import React from 'react';
import {
    GenericScreen, IconExclamationSquare, ParetoLogo,
} from '@paretogroup/tess';
import Loading from '@shared/components/loading/Loading';
import * as S from './splash-screen.styles';
import {
    TEST_ID, SIGN_OUT, PLEASE_WAIT, colors,
} from './splash-screen.constants';
import { ROUTES } from '../auth.constants';


type SplashScreenProps = {
    error: string,
    showSignOutButton: boolean,
}

export const SplashScreen = ({
    error,
    showSignOutButton,
}: SplashScreenProps) => {
    const classes = S.useStyles();

    const onClickSignOutButton = () => {
        window.location.href = ROUTES.SIGN_OUT;
    };

    return (
        <GenericScreen
            logo={(
                <ParetoLogo
                    colors={colors}
                />
            )}
            headerButton={
                showSignOutButton ? (
                    <div
                        data-testid={TEST_ID.SPLASH_SCREEN_SIGN_OUT_BUTTON}
                    >
                        <S.SignOutHeaderButton
                            onClick={onClickSignOutButton}
                            fullWidth
                        >
                            {SIGN_OUT}
                        </S.SignOutHeaderButton>
                    </div>
                ) : null
            }
            classes={classes}
            backgroundGradient={S.backgroundGradient}
        >
            <S.SplashScreenWrapper>
                { (error
                    ? (
                        <>
                            <IconExclamationSquare />
                            <S.MessageWrapper
                                data-testid={TEST_ID.SPLASH_SCREEN_ERROR_MESSAGE}
                            >
                                {error}
                            </S.MessageWrapper>
                        </>
                    )
                    : (
                        <>
                            <S.MessageWrapper
                                data-testid={TEST_ID.SPLASH_SCREEN_IMAGE}
                            >
                                {PLEASE_WAIT}
                            </S.MessageWrapper>
                            <Loading spinnerSize="30px" width="30px" height="30px" />
                        </>
                    )
                ) }
            </S.SplashScreenWrapper>
        </GenericScreen>
    );
};
